function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPurchaseHistoryRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 27a1.5 1.5 0 10-.001 2.999A1.5 1.5 0 007.5 27zM14.5 27a1.5 1.5 0 10-.001 2.999A1.5 1.5 0 0014.5 27zM6 14H2v2h2.336l1.663 8.994L6 25h10l1-7H6.728L6 14z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 14h-8V7h2v5h6v2zM19 2C12.925 2 8 6.925 8 13c0 .395.023.784.063 1.168l.265 1.455c.031.126.062.252.097.377h10.881l-.326 2.283-.811 5.675c.275.021.551.042.831.042 6.075 0 11-4.925 11-11S25.075 2 19 2z",
    fill: props.color
  }));
}

export default SvgIconPurchaseHistoryRexFilled;